import React from 'react';

function Logo(props) {
  return (
    <img
      alt="Logo"
      src="/static/fi-logo.svg"
      {...props}
    />
  );
}

export default Logo;
